import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Nova Run Club</p>
        <h1>Join the Run Revolution in Northern Virginia</h1>
        <p className="lede">
          Whether you're a seasoned marathoner or just starting your running journey, Nova Run Club welcomes you to a community that inspires and motivates. Join us for group runs, exciting events, and tailored training programs designed for runners of all levels.
        </p>
        <div className="cta-row">
          <a href="/join" className="primary">
            Become a Member
          </a>
          <a href="/events" className="secondary">
            Explore Upcoming Events
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Group Runs</h2>
          <p>
            Experience the joy of running with others. Our regular group runs are designed to foster camaraderie and support, no matter your pace.
          </p>
        </article>
        <article>
          <h2>Training Programs</h2>
          <p>
            Achieve your personal best with our structured training programs. Our expert coaches provide guidance tailored to your goals and experience level.
          </p>
        </article>
        <article>
          <h2>Community Events</h2>
          <p>
            Join us for fun and engaging events throughout the year. From charity runs to social gatherings, there's always something happening at Nova Run Club.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;